<div class="main-content1">
  <section class="hero-section">
    <div class="hero-content">
      <h1>Find the Perfect Equipment for Your Project</h1>
      <p>Rent construction equipment, vehicles, and machinery across the UAE</p>

      <!-- NEW REUSABLE SEARCH BAR COMPONENT -->
      <app-search-bar mode="landing"></app-search-bar>
    </div>
  </section>

  <div class="main-content">

    <!-- Categories -->
    <section class="categories" [hidden]="!isLoaded">
      <div *ngIf="categories$ | async as categories; else catSkeleton">
        <!-- Scrollable row -->
        <div #categoryScroll class="category-scroll" (scroll)="onScroll()">
          <div class="category-grid">
            <div class="cat-card" *ngFor="let category of categories" (click)="goToCategory(category.id)">
              <div class="cat-image">
                <img [src]="category.imageUrl || 'assets/default-category.jpg'" alt="{{ category.name }}"
                  (load)="onImageLoad()" (error)="onImageLoad()" />
              </div>
              <div class="cat-info">
                <h3>{{ category.name }}</h3>
                <p>{{ category.capacityLabel }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Custom centered scrollbar -->
        <div class="custom-scrollbar" [style.display]="showCategoryScrollbar ? 'block' : 'none'">
          <div #customThumb class="custom-thumb"></div>
        </div>
      </div>
      <ng-template #catSkeleton>
        <div class="skeleton-categories">
          <div class="skeleton skeleton-cat-card" *ngFor="let i of [1,2,3,4,5,6]"></div>
        </div>
      </ng-template>
    </section>

    <!-- ===========================================
     EQUIPMENT SECTION — PIXEL PERFECT REPLICA
     =========================================== -->

    <div [hidden]="!isLoaded">
      <div *ngIf="emirateEquipments$ | async as groups; else equipSkeleton">
        <section class="equipment-section" *ngFor="let group of groups">
          <!-- HEADER -->
          <div class="equipment-header">
            <h2>Equipments in {{ group.emirate }}</h2>
            <span class="view-all" (click)="viewAll(group.emirate)">View All</span>
          </div>

          <!-- 5-Card Row Grid -->
          <div class="equipment-grid">
            <div class="equipment-card" *ngFor="let equip of group.equipments"
              [routerLink]="['/booking-detail', equip.id]">
              <!-- IMAGE -->
              <div class="image-box">
                <div class="demo-badge-tag" *ngIf="equip.isDemo">
                  <span class="demo-dot"></span> DEMO
                </div>
                <img *ngIf="equip.images && equip.images.length > 0; else noImage" [src]="equip.images[0]"
                  (load)="onImageLoad()" (error)="onImageLoad()" />
                <ng-template #noImage>
                  <img src="assets/no-image-available.jpg" (load)="onImageLoad()" (error)="onImageLoad()" />
                </ng-template>
              </div>

              <div class="rating">
                ⭐ {{ equip.avgRating || 0 }}
                <span>({{ equip.totalReviews || 0 }})</span>
              </div>

              <!-- DETAILS -->
              <h3 class="equip-title">{{ equip.listingName || equip.name }}</h3>
              <p class="equip-brand">{{ equip.brand }}</p>
              <p class="equip-meta">
                Year of Mfr : {{ equip.year_of_manufacture || "2019" }}
              </p>

              <!-- PRICE -->
              <div class="equip-price">
                <span class="price-currency">AED</span>
                <span class="price-amount">{{ getRatePrice(equip) }}</span>
                <span class="price-period">{{ getRatePeriod(equip) }}</span>
              </div>
            </div>
          </div>
        </section>
      </div>

      <ng-template #equipSkeleton>
        <section class="equipment-section" *ngIf="!isLoaded">
          <div class="skeleton" style="height: 30px; width: 250px; margin-bottom: 20px;"></div>
          <div class="skeleton-equipment-grid">
            <div class="skeleton-equip-card" *ngFor="let i of [1,2,3,4,5,6]">
              <div class="skeleton skeleton-img"></div>
              <div class="skeleton skeleton-line"></div>
              <div class="skeleton skeleton-line short"></div>
            </div>
          </div>
        </section>
      </ng-template>

    </div><!-- end [hidden] wrapper -->

    <section class="equipment-section">
      <div class="equipment-header">
        <h2>Most in-demand</h2>
        <span class="view-all" (click)="viewAll()">View All</span>
      </div>

      <div class="equipment-grid">
        <div class="equipment-card" *ngFor="let equip of mostDemanded$ | async"
          [routerLink]="['/booking-detail', equip.id]">
          <div class="image-box">
            <div class="demo-badge-tag" *ngIf="equip.isDemo">
              <span class="demo-dot"></span> DEMO
            </div>
            <img *ngIf="equip.images && equip.images.length > 0; else noImage" [src]="equip.images[0]" />
            <ng-template #noImage>
              <img src="assets/no-image-available.jpg" alt="No image available" />
            </ng-template>
            <div class="tag">{{ equip.emirate }}</div>
          </div>

          <div class="rating">
            ⭐ {{ equip.avgRating || 0 }}
            <span>({{ equip.totalReviews || 0 }})</span>
          </div>

          <h3 class="equip-title">{{ equip.listingName || equip.name }}</h3>
          <p class="equip-brand">{{ equip.brand }}</p>
          <p class="equip-meta">
            Year of Mfr : {{ equip.year_of_manufacture || "2019" }}
          </p>

          <div class="equip-price">
            <span class="price-currency">AED</span>
            <span class="price-amount">{{ getRatePrice(equip) }}</span>
            <span class="price-period">{{ getRatePeriod(equip) }}</span>
          </div>
        </div>
      </div>
    </section>
  </div><!-- end main-content -->

  <!-- SERVICE CARDS -->
  <!-- <section class="service-cta-section">
    <div class="service-cta-grid">
      <div class="service-card">
        <img src="assets/landingpage/1.jpg" />
        <div class="overlay"></div>
        <div class="service-content">
          <h2>Is it time to get your vehicle serviced?</h2>
          <button>Book Garage</button>
        </div>
      </div>

      <div class="service-card">
        <img src="assets/landingpage/2.jpg" />
        <div class="overlay"></div>
        <div class="service-content">
          <h2>Is your vehicle due for passing test?</h2>
          <button>Book Services</button>
        </div>
      </div>

      <div class="service-card">
        <img src="assets/landingpage/3.jpg" />
        <div class="overlay"></div>
        <div class="service-content">
          <h2>Did your vehicle face a sudden breakdown?</h2>
          <button>Book Tow Truck</button>
        </div>
      </div>
    </div>
  </section> -->

  <!-- BECOME VENDOR -->
  <section class="become_vendor">
    <h1>Want to become a vendor on Aluguloo?</h1>
    <button class="become_btn" (click)="openServiceOfferDialog()">Let's Connect</button>
  </section>

  <!-- AI ASSISTANT -->
  <app-ai-button (clicked)="aiOpen = true">
  </app-ai-button>

  <app-ai-drawer [isOpen]="aiOpen" (closed)="aiOpen = false">
  </app-ai-drawer>
</div>